/**
 * "2026-09-01" → "September 2026", in the reader's language.
 *
 * TWO THINGS HERE ARE NOT DECORATION.
 *
 * **`timeZone: 'UTC'`, and it is mandatory.** `new Date('2026-09-01')` parses
 * as UTC midnight, and a formatter left on the viewer's zone renders that
 * moment in *their* offset — so an issue dated the 1st of the month reads
 * "August 2026" for every reader west of Greenwich, and "September 2026" for
 * everyone here, which is the kind of bug that gets reported as "it looks fine
 * to me". The date on an issue is a fact about the issue, not about who is
 * reading it, so it is formatted in the zone it was written in.
 *
 * **One formatter per locale, cached.** `Intl.DateTimeFormat` construction is
 * the expensive half, and the prerender walks every route × every locale.
 *
 * Month names come from ICU rather than from the dictionary, which is the one
 * arguable call: the alternative is twelve strings in `content/en.ts` and
 * twelve in `content/tr.ts`. ICU wins because these are not editorial copy and
 * nobody should be able to translate "September" differently on two pages — but
 * it means the prerender and the browser must agree, or the date flickers on
 * hydration. `scripts/gate-test.mjs` asserts both languages in Node, which is
 * where a build without full ICU would show up ("M09 2026" instead of
 * "September 2026").
 */
const FORMATTERS = new Map<string, Intl.DateTimeFormat>()

export function issueDateLabel(date: string, locale: string): string {
  let fmt = FORMATTERS.get(locale)
  if (!fmt) {
    fmt = new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long', timeZone: 'UTC' })
    FORMATTERS.set(locale, fmt)
  }
  return fmt.format(new Date(`${date}T00:00:00Z`))
}
